import useMutation from "src/hooks/useMutation";

function useScanBulkReturnProcessing(id) {
  return useMutation({
    path: `/api/v1/return-logs/${id}/process`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/return-logs/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useScanBulkReturnProcessing;
